import API from './apiConfig';

export const checkEligibility = async (formData) => {
  try {
    const response = await API.post('/checkEligibility', formData);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};

export const resendAdmissionEmail = async (formData) => {
  try {
    const response = await API.post('/resend_admission_email', formData);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
};
